import { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { toast } from "sonner";

export const NewsletterSection = () => {
  const [newsletter, setNewsletter] = useState("");

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (!newsletter) return;
    toast.success("You're on the list. Look for our next dispatch.");
    setNewsletter("");
  };

  return (
    <section data-testid="newsletter-section" className="px-6 md:px-12 lg:px-24 py-20 border-b border-[#E5E0D8]">
      <div className="grid grid-cols-12 gap-y-10 gap-x-4 lg:gap-10 items-center">
        <div className="col-span-12 lg:col-span-7">
          <p className="label-eyebrow text-[#1E3A8A]">— Newsletter</p>
          <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight font-medium mt-3 text-[#111]">
            Stay inspired with our dispatch
          </h2>
          <p className="text-[#555] mt-3 max-w-xl">
            Be the first to discover new artworks, featured artists and exclusive offers.
            Delivered monthly. No spam.
          </p>
        </div>
        <form onSubmit={handleNewsletter} className="col-span-12 lg:col-span-5 flex gap-3">
          <Input
            data-testid="newsletter-input"
            type="email"
            required
            value={newsletter}
            onChange={(e) => setNewsletter(e.target.value)}
            placeholder="Your email address"
            className="flex-1 rounded-none border border-[#1E3A8A] bg-white px-4 py-3 h-auto focus-visible:ring-0 focus-visible:border-[#1E3A8A]"
          />
          <Button
            type="submit"
            data-testid="newsletter-submit"
            className="rounded-none bg-[#1E3A8A] hover:bg-[#F4C430] hover:text-[#1E3A8A] text-white px-7 h-auto label-eyebrow"
          >
            Subscribe
          </Button>
        </form>
      </div>
    </section>
  );
};
